import {
	AmberSidely,
	BlueGreySidely,
	PrimaryColor,
	BlushSidely,
	BrightRedSidely,
	BrightTealSidely,
	BrightYellowSidely,
	BrownSidely,
	BurntOrangeSidely,
	CeruleanSidely,
	CoralSidely,
	CoolGreySidely,
	EmeraldSidely,
	ForestGreenSidely,
	GreenSidely,
	IndigoSidely,
	LavenderSidely,
	LightCyanSidely,
	LightLavenderSidely,
	LightPeachSidely,
	LightPinkSidely,
	LightTealSidely,
	LimeGreenSidely,
	LimeYellowSidely,
	MauveSidely,
	MediumPurpleSidely,
	OliveSidely,
	OrangeSidely,
	PeachSidely,
	PeriwinkleBlueSidely,
	PlumSidely,
	RedSidely,
	SalmonSidely,
	SiennaSidely,
	SkyBlueSidely,
	SlateSidely,
	SteelBlueSidely,
	TealSidely,
	YellowGreenSidely,
	YellowSidely,
} from '../../../styles/global/css/Utils';

const colorList = [
	PrimaryColor,
	CeruleanSidely,
	ForestGreenSidely,
	TealSidely,
	BrightTealSidely,
	SteelBlueSidely,
	EmeraldSidely,
	GreenSidely,
	PeriwinkleBlueSidely,
	SlateSidely,
	IndigoSidely,
	PlumSidely,
	SkyBlueSidely,
	MauveSidely,
	MediumPurpleSidely,
	LimeGreenSidely,
	CoolGreySidely,
	BrownSidely,
	LavenderSidely,
	LightTealSidely,
	BlueGreySidely,
	OliveSidely,
	SiennaSidely,
	YellowGreenSidely,
	LightCyanSidely,
	LightLavenderSidely,
	BurntOrangeSidely,
	PeachSidely,
	LimeYellowSidely,
	YellowSidely,
	LightPeachSidely,
	LightPinkSidely,
	BrightRedSidely,
	SalmonSidely,
	RedSidely,
	BlushSidely,
	OrangeSidely,
	AmberSidely,
	CoralSidely,
	BrightYellowSidely,
];

export const colorGradient = [
	BlushSidely,
	LightPinkSidely,
	SalmonSidely,
	RedSidely,
	BrightRedSidely,
	CoralSidely,
	OrangeSidely,
	AmberSidely,
	BrightYellowSidely,
	YellowSidely,
	LimeYellowSidely,
	YellowGreenSidely,
	LimeGreenSidely,
	GreenSidely,
	EmeraldSidely,
	ForestGreenSidely,
	TealSidely,
	BrightTealSidely,
	LightTealSidely,
	LightCyanSidely,
	SkyBlueSidely,
	CeruleanSidely,
	SteelBlueSidely,
	PeriwinkleBlueSidely,
	PrimaryColor,
	IndigoSidely,
	MediumPurpleSidely,
	LavenderSidely,
	LightLavenderSidely,
	PlumSidely,
	MauveSidely,
	SlateSidely,
	CoolGreySidely,
	BlueGreySidely,
	OliveSidely,
	BrownSidely,
	SiennaSidely,
	BurntOrangeSidely,
	PeachSidely,
	LightPeachSidely,
];

export function getColorFromList(str: string): string {
	if (!str) return 'none';
	if (str && str.length > 0) {
		let hash = 0;
		for (let i = 0; i < str.length; i++) {
			hash = str.charCodeAt(i) + ((hash << 5) - hash);
		}
		const index = hash % colorList.length;
		return colorList[Math.abs(index)];
	} else return '#49B3FE';
}

export default colorList;
